export const getGoogleLocationAddressStructure = (address) => {
  return {
    id: address?.id,
    country: address?.county,
    locality: address?.town,
    street: address?.address1,
    postalcode: address?.postCode,
    region: address?.region,
    latitude: address?.latitude,
    longitude: address?.longitude,
  }
}
